// extracted by mini-css-extract-plugin
module.exports = {"list":"SimpleList_list_2yzw5","line":"SimpleList_line_lhITZ","bottom_line":"SimpleList_bottom_line_kMEPN"};